<template>
	<div class="notData">
		<img class="img" src="../assets/img/cat-in-space@1x.png" />
		<div class="mes-text">{{text}}</div>
	</div>
</template>

<script>
	export default{
		name:'NotData',
		props:{
			text:{
				type:String,
				default:'No data'
			}
		},
		data(){
			return{
				
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.notData{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.img{
			width: 36%;
			margin-top: 50px;
		}
		.mes-text{
			position: relative;
			font-size: 14px;
			color: #A2A2A2;
			line-height: 30px;
			margin-bottom: 50px;
		}
	}
</style>
